import React, {ReactElement} from 'react';
import '../../../../index.less';
import NumberFormatView from '../../../../shared/components/NumberFormatView/NumberFormatView';
const DashboardCard = (props: any): ReactElement => {
  const {title, body, width, prefixRequired = false} = props || {};
  return(
    <div className={width}>
      <div className="cardclass w-100 mx-5 p-sm flex-element flex-col justify-center items-center reconciliation-dashboard-border text-primary">
        <div className="color-navy bold">{title}</div>
        <div className="extra-bold color-navy fsize_2xl">
          {
            prefixRequired ?
            <NumberFormatView prefix="₹ " amount={body} fixedDecimalScale={false} />
            : <div>{body}</div>
          }
        </div>
      </div>
    </div>
  );
};
export default DashboardCard;
